import { useState, useEffect } from "react";
import leftImg from "../../assets/leftsImg.png";
import rightImg from "../../assets/rImg.png";
import eyeLock from "../../assets/visibility_lock.png";
import ReCAPTCHA from "react-google-recaptcha";
import "../../styles/Login.css";
import { useNavigate } from "react-router-dom";
import { handleError, handleSuccess } from "../../utils/Service/utils";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { base_url } from "../../utils/apiConfig";
import { useTenantContext } from "../../utils/Context/TenantsContext";

const Login = () => {
  const tenant = useTenantContext();
  const navigate = useNavigate();

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleCaptchaChange = (value) => {
    setCaptchaValue(!!value);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
    if (name === "email") {
      setIsValid(value.includes("@"));
    }
  };

  const handleLoginClick = async (e) => {
    e.preventDefault();
    if (!credentials.email) {
      handleError("Email cannot be empty!");
      return;
    }
    if (!credentials.password) {
      handleError("Password cannot be empty!");
      return;
    }
    if (!captchaValue) {
      handleError("CAPTCHA not verified. Please fill the CAPTCHA.");
      return;
    }
    if (credentials.email && credentials.password) {
      setLoading(true);
      const fullUrl = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/web_login_api`;
      try {
        const formData = new FormData();
        formData.append("username", credentials.email);
        formData.append("password", credentials.password);
        const response = await axios.post(fullUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        localStorage.setItem("authToken", response.data.token);
        handleSuccess("Login successful");
        window.scrollTo(0, 0);
        const getApiUrl = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/user`;
        const getResponse = await axios.get(getApiUrl, {
          headers: {
            Authorization: `Token ${response.data.token}`,
          },
        });

        localStorage.setItem("userDetails", JSON.stringify(getResponse.data));

        const getApiEmailUrl = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/email_notification`;
        const getEmailResponse = await axios.get(getApiEmailUrl, {
          headers: {
            Authorization: `Token ${response.data.token}`,
          },
        });
        localStorage.setItem(
          "userEmailDetails",
          JSON.stringify(getEmailResponse.data)
        );
        setTimeout(
          () =>
            navigate("/dashboard", {
              replace: true,
              state: {
                data: getResponse.data,
                emailData: getEmailResponse.data,
              },
            }),
          800
        );
      } catch (error) {
        console.log("An error occurred:", error);
        handleError("Invalid credentials");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleCLickPortal = () => {
    window.open(tenant?.auditorPortalUrl, "_blank"); // need to change the url for audiot portal to amek 
  };

  return (
    <div>
      <nav className="header ps-3">
        <img src={tenant?.logo7x} alt="Logo" className="logo1" />
      </nav>

      <div className="hero-section d-flex">
        <div className="leftImg">
          <img
            src={leftImg}
            alt="img"
            className={`${screenWidth < 1024 ? "img-fluid" : ""}`}
          />
        </div>

        <div className="mainDiv mt-5 mb-4">
          <div className="welcome mx-auto d-flex flex-column align-items-center">
            <p className="wel">Welcome to</p>
            <p className="flp">{tenant?.name} Client Portal</p>
          </div>

          <div className="out-logDiv">
            <div
              style={{ backgroundColor: "#FCFCFC" }}
              className="login-div mx-auto mt-3 shadow-lg p-3"
            >
              <div className="inner text-center">
                <p style={{ fontSize: "2rem" }}>
                  <span>Login</span>{" "}
                </p>
              </div>
              <div className="details mt-4">
                <div className="my-3 lab-inp">
                  <label className="form-label">Email Id :</label>
                  <input
                    type="email"
                    name="email"
                    className={`form-control ${isValid ? "is-valid" : "is-invalid"
                      }`}
                    onChange={handleChange}
                    id="exampleInputEmail1"
                    value={credentials.email}
                    placeholder="Enter your email"
                  />
                  {credentials.email && (
                    <small className={`text-${isValid ? "success" : "danger"}`}>
                      {isValid ? "Valid Email" : "Invalid Email"}
                    </small>
                  )}
                </div>

                <div className="my-3 lab-inp">
                  <label className="form-label">Password :</label>
                  <div className="input-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      name="password"
                      onChange={handleChange}
                      id="exampleInputPassword1"
                      placeholder="Enter your password"
                    />
                    <img
                      onClick={togglePasswordVisibility}
                      style={{ cursor: "pointer" }}
                      src={eyeLock}
                      alt="Toggle visibility"
                      className="toggle-icon"
                    />
                  </div>
                </div>

                <div className="robot-div">
                  <div>
                    <ReCAPTCHA
                      sitekey="6LdifggtAAAAAHHHMNT-zfDV8i-mB-fJeNENu9fi"
                      onChange={handleCaptchaChange}
                      style={{
                        transform: "scale(1, 0.85)",
                        transformOrigin: "0 0",
                      }}
                    />
                  </div>
                </div>
                <div
                  onClick={handleLoginClick}
                  disabled={!captchaValue}
                  className="text-center"
                >
                  <button className="login-btn" disabled={loading}>{loading ? "Logging..." : "Log In"}</button>
                </div>
              </div>
              <div className="audit-login ms-2 pt-2">
                <p style={{ fontSize: "14px" }}>
                  For auditor login{" "}
                  <span
                    className="ms-1"
                    onClick={handleCLickPortal}
                    style={{ cursor: "pointer" }}
                  >
                    Auditor login ?
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="rightImg">
          <img
            src={rightImg}
            alt="img"
            className={`${screenWidth < 1024 ? "img-fluid" : ""}`}
          />
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};


export default Login;
